import React, { useState, useEffect } from 'react'
import { useParams } from 'react-router-dom'
import { getWere } from 'src/api/contenfull'
import { Header } from 'src/components/common/TitleSection'
import { SectionInformation } from './SectionInformation'
import { IVacancyFields } from 'src/types/contenfull'
import { Helmet } from 'react-helmet'
import { useTranslations, useI18nInstance } from 'src/provider/LocaleProvider'
import { OverContainerLoading, PLoadingC } from 'src/components'
import Lottie from 'lottie-react'
import Loading from 'src/components/layout/Main/loading.json'

export function DetailedWere() {
    const t = useTranslations()
    const i18n = useI18nInstance()
    const { id } = useParams()
    const [were, setWere] = useState<IVacancyFields | null>(null)

    useEffect(() => {
        if (id) {
            (async () => {
                const resp = await getWere(String(id))
                setWere((resp?.fields as IVacancyFields) || null)
            })()
        }
    }, [getWere, id])

    if (!were) {
        return (
            <OverContainerLoading>
                <PLoadingC>
                    <Lottie animationData={Loading} loop={true} />
                </PLoadingC>
            </OverContainerLoading>
        )
    }
    const officio = were?.officio
    return (
        <>
            <Helmet>
                <title>
                    {officio ?? ''} - {t('WorldWile.complement.title')}
                </title>
                <meta
                    name="description"
                    content={t('WorldWile.WorldWile.description') ?? ''}
                />
            </Helmet>

            <Header
                title={officio}
                subTitle={
                    i18n.language === 'es'
                        ? were.localicaionSpanish
                        : were.localicaion
                }
                image={'/src/assets/WereHiring/HeaderDet.avif'}
            />
            <SectionInformation were={were} />
        </>
    )
}
